import { action, makeObservable } from 'mobx';
import { RatesOverriderDelegate } from 'store/modules/override-rates/ratesOverriderDelegate';
import { QuotedProductRatesForm } from './quotedProductRatesForm';
import { OverrideProduct } from './pageStore';

interface Props {
  quotedProducts: OverrideProduct[];
}

export class QuotedRatesOverriderDelegate extends RatesOverriderDelegate {
  public rateForms: QuotedProductRatesForm[] = [];

  public restoreInitialRates(): void {
    this.rateForms.forEach((rateForm) => {
      rateForm.resetToInitialRates();
    });
  }

  public createRateForms(quotedProducts: OverrideProduct[]): void {
    this.rateForms = quotedProducts.map((quotedProduct) => new QuotedProductRatesForm({ quotedProduct }));
  }

  constructor(props: Props) {
    super({
      products: props.quotedProducts.map((quotedProduct) => ({
        productName: quotedProduct.productName,
        rates: quotedProduct.productSummary.rates,
        portfolioId: quotedProduct.portfolioId,
        productId: quotedProduct.productId,
        bcIndex: quotedProduct.bcIndex,
      })),
    });

    makeObservable<QuotedRatesOverriderDelegate>(this, {
      createRateForms: action.bound,
    });
  }
}
